{
  "groups": {
    "pricing": "Pricing",
    "settings": "Settings",
    "integrations": "Integrations",
    "storefront": "Storefront",
    "sales_agents": "Sales agents",
    "companies": "Companies"
  },
  "tabs": {
    "price_lists": "Price lists",
    "price_editor": "Price editor",
    "discounts": "Discounts",
    "configurations": "Configurations",
    "shipping": "Shipping",
    "api": "API",
    "templates": "Templates",
    "platform": "Platform",
    "partners": "Partners",
    "product_sync": "Product sync",
    "widgets": "Widgets",
    "options": "Options",
    "sales_agents": "Sales agents",
    "roles": "Roles",
    "companies": "Companies",
    "customers": "Customers",
    "customer_groups": "Customer groups"
  }
}
